export default "__VITE_ASSET__DjTdNl6s__"